import * as React from "react";
const SvgInternalGraining = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 128 128", contentScriptType: "text/ecmascript", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1.627 66.17h125.288", style: {
  fill: "#e42c00",
  fillOpacity: 1,
  stroke: "#e42c00",
  strokeWidth: 4,
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  strokeDasharray: "24,24",
  strokeDashoffset: 0,
  strokeOpacity: 1
} }));
export default SvgInternalGraining;
